/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imgdesign_Err_Name_Required1Inputs */

const vi_imgdesign_err_name_required1 = /** @type {(inputs: Imgdesign_Err_Name_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập tên sản phẩm hiện trên ảnh`)
};

/**

* @param {Imgdesign_Err_Name_Required1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const imgdesign_err_name_required1 = /** @type {((inputs?: Imgdesign_Err_Name_Required1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imgdesign_Err_Name_Required1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_imgdesign_err_name_required1(inputs)
});
export { imgdesign_err_name_required1 as "imgDesign_err_name_required" }